import {
  filter, prop, values, mapObjIndexed,
} from 'ramda';

import { actions } from '@ezugi/bootstrap';
import { buildSocketSendPayload } from '@ezugi/bootstrap/src/store/epics/socket/buildSocketSendPayload';

import { currentBetsSelector, betsHistorySelector } from '../../../selectors/bets';

import { getTotalBet } from '.';

const { socketActions, notificationActions, betActions, userActions } = actions;

export const buildParams = (bets, state) => ({
  ...buildSocketSendPayload(state),
  BetsList: bets,
});

const keepValidBets = filter(prop('valid'));

export const createBetsList = (bets) => ({
  betsList: bets,
});
export const createPlaceBetRequestPayload = (state) => {
  const currentBetsList = currentBetsSelector(state);
  const betHistory = betsHistorySelector(state);
  const _actions = [];

  // at reconnect, bet history is reset, contains only the default entry, and this way we avoid re-sending bets to GE
  if (betHistory.length <= 1) return _actions;

  const currentBets = values(currentBetsList);

  if (currentBets.length) {
    const validBetsList = keepValidBets(currentBetsList);
    const totalBet = getTotalBet(validBetsList);

    const validBetsCount = values(validBetsList).length;

    if (currentBets.length > validBetsCount) {
      // Remove invalid bets and update `TotalBet` and `BetHistory`
      _actions.push(notificationActions.notification.add({ message: 'notifications.bet_below_min_limits_removed' }));
      _actions.push(betActions.history.update({ current: validBetsList }));

      if (totalBet === 0) { // also update balance back to initial amount
        _actions.push(userActions.user.updateRealtimeBalanceWhenMainBetUnderLimit());
      }
      _actions.push(betActions.totalBet.set({ value: totalBet }));
    }

    // Cache valid bets for `Rebet`
    if (validBetsCount) {
      _actions.push(betActions.bet.cache({ current: validBetsList, totalBet }));
    }

    const bets = mapObjIndexed((value, key) => ({
      betValue: value.value,
      index: key,
    }), validBetsList);

    const params = buildParams(values(bets), state);
    _actions.push(socketActions.socket.send(params));
  }

  return _actions;
};
